export const light = {
   alternate: {
      main: "#f7faff",
      dark: "#edf1f7",
   },
   cardShadow: "rgba(23, 70, 161, .11)",
   mode: "light",
   common: {
      black: "#000",
      white: "#fff",
   },
   primary: {
      main: "#497edf",
      light: "#467de3",
      dark: "#1a202c",
      contrastText: "#fff",
   },
   secondary: {
      light: "#FF9400",
      main: "#FF5D0A",
      dark: "#FF3E12",
      contrastText: "#fff",
   },
   text: {
      primary: "#1e2022",
      secondary: "#5b667d",
   },
   divider: "rgba(0, 0, 0, 0.12)",
   background: {
      paper: "#ffffff",
      default: "#ffffff",
      level2: "#f2f4fb",
      level1: "#f5f5f5",
   },
   zesty: {
      zestyDarkBlue: "#1b202c",
      zestyTabBlue: "#697A91",
      zestyOrange: "#FF5D0A",
      zestyRed: "rgb(230,74,23)",
      devTheme: "#77b250",
      zestyGreen: "#75BF43",
      zestyBlue: "#497edf",
      zestyTeal: "#6a9293",
      zestyWhite: "#eff5ff",
      bulmaBlue: "#336fdb",
      zestyLightBlue: "#C3CDDF",
      zestyFieldBlue: "#C7D4EA",
      zestyBackgroundBlue: "#D6E8F5",
      zestyGrey: "#5B667D",
      zestyLightGrey: "#A7AFBF",
      navBorderColor: "#3c465e",
      yellowHighlight: "#FFFDE2",
      zestyYellow: "rgb(249, 185, 52)",
      white: "#ffffff",
      black: "#000000",
      zestyWhiteBlue: "#f2f4fb",
      zestyPink: "#EA398C",
      darkBlue: "#1B1F2C",
      parsleyGreen: "#96C45B",
      headerColor: "#CFDCFF",
      pureWhite: "#ffffff",
      lightBlue: "#D9E2F4",
   },
}

export const dark = {
   alternate: {
      main: "#1a2138",
      dark: "#151a30",
   },
   cardShadow: "rgba(0, 0, 0, .11)",
   common: {
      black: "#000",
      white: "#fff",
   },
   mode: "dark",
   primary: {
      main: "#1976d2",
      light: "#2196f3",
      dark: "#0d47a1",
      contrastText: "#fff",
   },
   secondary: {
      light: "#FF9400",
      main: "#FF5D0A",
      dark: "#FF3E12",
      contrastText: "#fff",
   },
   text: {
      primary: "#EEEEEF",
      secondary: "#AEB0B4",
   },
   divider: "rgba(255, 255, 255, 0.12)",
   background: {
      paper: "#1a202c",
      default: "#1a202c",
      level2: "#3c465e",
      level1: "#2D3748",
   },
   zesty: {
      zestyDarkBlue: "#1b202c",
      zestyTabBlue: "#697A91",
      zestyOrange: "#FF5D0A",
      zestyRed: "rgb(230,74,23)",
      devTheme: "#77b250",
      zestyGreen: "#75BF43",
      zestyBlue: "#497edf",
      zestyTeal: "#6a9293",
      zestyWhite: "#eff5ff",
      bulmaBlue: "#336fdb",
      zestyLightBlue: "#C3CDDF",
      zestyFieldBlue: "#C7D4EA",
      zestyBackgroundBlue: "#D6E8F5",
      zestyGrey: "#5B667D",
      zestyLightGrey: "#A7AFBF",
      navBorderColor: "#3c465e",
      yellowHighlight: "#FFFDE2",
      white: "#ffffff",
      black: "#000000",
      zestyWhiteBlue: "#f2f4fb",
      zestyPink: "#EA398C",
      darkBlue: "#1B1F2C",
      parsleyGreen: "#96C45B",
      headerColor: "#CFDCFF",
      pureWhite: "#ffffff",
      lightBlue: "#D9E2F4",
   },
}
